import styled from 'styled-components'

const Table = styled.div`

`

export default Table
